// React Imports
import * as React from 'react';
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

// App Imports
import SeriesCdpStatsGrid from "./SeriesCdpStats";
import SeasonCdpStatsGrid from "./SeasonCdpStats";
import EpisodeCdpStatsGrid from "./EpisodeCdpStats";
import {changeCdpStats} from "./cdpStatsSlice";
import GuildCdpStatsGrid from "./GuildCdpStats";
import MarketGroupCdpStatsGrid from "./MarketGroupCdpStats";
import ReleaseMarketCdpStatsGrid from "./ReleaseMarketCdpStats";
import ContractTypeCdpStatsGrid from "./ContractTypeCdpStats";


// main function
export default function CdpStatsFrame(props) {


    const selectorSeriesId = useSelector((state) => state.cdpStatsSlc.value.seriesId);
    const selectorSeasonId = useSelector((state) => state.cdpStatsSlc.value.seasonId);
    const selectorProductId = useSelector((state) => state.cdpStatsSlc.value.productId);
    const selectorSeriesTitle = useSelector((state) => state.cdpStatsSlc.value.seriesTitle);
    const selectorSeasonName = useSelector((state) => state.cdpStatsSlc.value.seasonName);
    const selectorEpisodeName = useSelector((state) => state.cdpStatsSlc.value.episodeName);
    const selectorPhotoStartDate = useSelector((state) => state.cdpStatsSlc.value.photoStartDate);
    const selectorGridDisplay = useSelector((state) => state.cdpStatsSlc.value.gridDisplay);
    const dispatchData = useDispatch();

    const handleGridDisplayAll = (level)  => {
        dispatchData(changeCdpStats({seriesId: null, seriesTitle: null,seasonId: null, seasonName: null,
            productId: null, episodeName: null, photoStartDate: null, gridDisplay: level}))};

    const handleGridDisplaySeries = (level)  => {
        dispatchData(changeCdpStats({seriesId: selectorSeriesId, seriesTitle: selectorSeriesTitle, seasonId: null, seasonName: null,
            productId: null, episodeName: null, photoStartDate: null, gridDisplay: level}))};


    const handleGridDisplaySeason = (level)  => {
        dispatchData(changeCdpStats({seriesId: selectorSeriesId, seriesTitle: selectorSeriesTitle, seasonId: selectorSeasonId, seasonName: selectorSeasonName,
            productId: null, episodeName: null, photoStartDate: null, gridDisplay: level}))};


    return (


        <div>
            {/*{useSelector((state) => state.cdpStatsControlsSlc.value.gridDisplay)}*/}
            { (selectorGridDisplay === "SeriesFullScreen" || selectorGridDisplay === "SeasonFullScreen" || selectorGridDisplay === "EpisodeFullScreen")  &&
                <Stack direction={"row"} spacing={2}>
                    <Box>
                        <h3 style={{cursor: 'pointer'}} onClick={() => handleGridDisplayAll("SeriesFullScreen")}>  All Series</h3>
                    </Box>
                    <Box>
                        {selectorSeriesId !== null && <h3>{' >'}</h3>}
                    </Box>
                    <Box>
                        <h3 style={{cursor: 'pointer'}}
                            onClick={() => handleGridDisplaySeries("SeasonFullScreen")}> {selectorSeriesTitle}</h3>
                    </Box>
                    <Box>
                        {selectorSeasonId !== null && <h3>{' >'}</h3>}
                    </Box>
                    <Box>
                        <h3 style={{cursor: 'pointer'}}
                            onClick={() => handleGridDisplaySeason("EpisodeFullScreen")}
                        > {selectorSeasonName}</h3>
                    </Box>
                    <Box>
                        {selectorProductId !== null && <h3>{' >'}</h3>}
                    </Box>
                    <Box>
                        {selectorProductId !== null && <h3 style={{cursor: 'pointer'}}
                        > {selectorEpisodeName} ( {selectorProductId}, {selectorPhotoStartDate} )</h3>}
                    </Box>
                </Stack>}
            <div>
                {selectorGridDisplay === "ContractTypeCdpStats" && <ContractTypeCdpStatsGrid/>}
                {selectorGridDisplay === "MarketGroupCdpStats" && <MarketGroupCdpStatsGrid/>}
                {selectorGridDisplay === "ReleaseMarketFullScreen" && <ReleaseMarketCdpStatsGrid/>}

                {/*{selectorGridDisplay === "SeriesFullScreen" && <StandAloneCdpStatsGrid/>}*/}
                {/*{selectorGridDisplay === "SeriesFullScreen" && <ReleaseMarketCdpStatsGrid/>}*/}
                {/*{selectorGridDisplay === "SeriesFullScreen" && <MarketGroupCdpStatsGrid/>}*/}
                {selectorGridDisplay === "SeriesFullScreen" && <SeriesCdpStatsGrid/>}
                {selectorGridDisplay === "SeasonFullScreen" && <SeasonCdpStatsGrid/>}
                {selectorGridDisplay === "EpisodeFullScreen" && <EpisodeCdpStatsGrid/>}
                {selectorGridDisplay === "GuildFullScreen" && <GuildCdpStatsGrid/>}
            </div>
        </div>

    );

}
